// extracted by mini-css-extract-plugin
module.exports = {"component":"e6JzD","content":"_2NrfD","button":"QY24c","buttonIcon":"_35A_4","message":"_1WRT0"};